import type { Group } from "@/lib/types";

const DAY_INDEX: Record<string, number> = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

function dayOffset(group: Group, todayIndex: number): number {
  return (
    (((group.meeting_day ? DAY_INDEX[group.meeting_day] : undefined) ?? 0) -
      todayIndex +
      7) %
    7
  );
}

function compareDistance(a: Group, b: Group): number {
  if (a.distance_km != null && b.distance_km != null) {
    return a.distance_km - b.distance_km;
  }
  if (a.distance_km != null) {
    return -1;
  }
  if (b.distance_km != null) {
    return 1;
  }
  return 0;
}

export function sortGroups(groups: Group[]): Group[] {
  const todayIndex = new Date().getDay();
  const hasDistance = groups.some((g) => g.distance_km != null);

  return groups.slice().sort((a, b) => {
    // When distance data is present (geo path), proximity is the primary key.
    if (hasDistance) {
      const distCompare = compareDistance(a, b);
      if (distCompare !== 0) {
        return distCompare;
      }
    }

    const dayDiff = dayOffset(a, todayIndex) - dayOffset(b, todayIndex);
    if (dayDiff !== 0) {
      return dayDiff;
    }

    const timeCompare = (a.meeting_start_time ?? "").localeCompare(
      b.meeting_start_time ?? ""
    );
    if (timeCompare !== 0) {
      return timeCompare;
    }

    if (!hasDistance) {
      const distCompare = compareDistance(a, b);
      if (distCompare !== 0) {
        return distCompare;
      }
    }

    return a.name.localeCompare(b.name);
  });
}
